export const COUNTRY_US = 'United States';
export const COUNTRY_POSTOFFICE = 'POSTOFFICE';
export const COUNTRY_FOREIGN = 'INTERNATIONAL';
